import useApiGetWithPagination, {
  PaginationOptions,
} from "hooks/api/useApiGetWithPagination";
import endpoints from "hooks/api/endpoints";
import useProject from "hooks/useProject";
import { useMemo } from "react";
import ScriptDto from "types/ScriptDto";

interface Params {
  includeQuestions?: boolean;
  sort?: keyof ScriptDto;
  options?: PaginationOptions;
}

const DEFAULT_PARAMS: Params = {
  includeQuestions: false,
  sort: "title",
};

export default function useGetScripts(params: Params = {}) {
  const { includeQuestions, sort, options } = {
    ...params,
    ...DEFAULT_PARAMS,
  };

  const { projectId } = useProject();
  const { combinedPageResults, ...rest } = useApiGetWithPagination<ScriptDto>(
    endpoints.getAllScript(projectId, { includeQuestions, sort }),
    { options },
  );

  const { byId } = useMemo(
    () => ({
      byId: (combinedPageResults || []).reduce((prev, script) => {
        prev[script.id] = script;
        return prev;
      }, {}),
    }),
    [combinedPageResults],
  ) as { byId: Record<string, ScriptDto> };

  return { byId, combinedPageResults, ...rest };
}
